import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities, resetEntity } from '@redux/entities'

import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contenthouse/providerV4/FETCH_REQUEST'
const FETCH_SUCCESS = 'contenthouse/providerV4/FETCH_SUCCESS'
const FETCH_FAILURE = 'contenthouse/providerV4/FETCH_FAILURE'

// Initial State
const initialState = {
  errors: [],
  loaded: false,
  loading: false,
  result: {},
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Action Creators
export function loadProvidersV4(options){
  const { loadNext, ...apiOptions } = options

  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/v4/users', { ...apiOptions, roles: 'Provider' })
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.PROVIDERV4_ARRAY)

        if (loadNext) {
          dispatch(updateEntities(normalizedJson))
        } else {
          dispatch(resetEntity({ entities: { providersV4: normalizedJson.entities.providersV4 || {} } }))
        }

        dispatch(fetchSuccess({ data, hasMore: data.length === apiOptions.size }))

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function loadBlacklistedProvidersV4(options){
  const { clientId, ...apiOptions } = options

  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api(`/v4/clients/${clientId}/blacklisted-providers`, apiOptions)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.PROVIDERV4_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess({ data }))

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function loadZoneProvidersV4(zoneId, options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api(`/v4/zones/${zoneId}/providers`, options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.PROVIDERV4_ARRAY)
        dispatch(updateEntities(normalizedJson))

        const zoneProviders = {
          linkedProviders: data,
        }
        dispatch(fetchSuccess(zoneProviders))

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { type, payload } = action

  switch (type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
        result: { ...state.result, ...payload },
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
